import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import {
    NgbCollapseModule,
    NgbModalModule,
    NgbTabsetModule,
} from '@cmps/ng-bootstrap';
import { CmpsIconModule } from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../common/common.module';
import { CmpsLazyI18nModule } from '../i18n/i18n.module';

import { ModalNotificationComponent } from './modal.notification.component';
import { NotificationPanelComponent } from './notification-panel.component';
import { NotificationPanelService } from './notification-panel.service';
import {
    NotificationBodyDirective,
    NotificationComponent,
} from './notification.component';
import { TranslationIdMap } from './notification.i18n';
import { NotificationService } from './notification.service';

@NgModule({
    imports: [
        CommonModule,
        NgbCollapseModule,
        NgbModalModule,
        NgbTabsetModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsCommonModule,
        CmpsIconModule,
    ],
    providers: [NotificationService],
    declarations: [
        NotificationBodyDirective,
        NotificationComponent,
        ModalNotificationComponent,
        NotificationPanelComponent,
    ],
    exports: [NotificationPanelComponent],
})
export class CmpsNotificationModule {
    static forRoot(): ModuleWithProviders<CmpsNotificationModule> {
        return {
            ngModule: CmpsNotificationModule,
            providers: [NotificationPanelService],
        };
    }
}
